'use strict';

var namespace = 'modelEdit:';

module.exports = {
  MATERIAL_OPTION_SELECTED: namespace + 'MATERIAL_OPTION_SELECTED',
  MATERIAL_NAV_CLOSED: namespace + 'MATERIAL_NAV_CLOSED',
  MATERIAL_NAV_UPDATED: namespace + 'MATERIAL_NAV_UPDATED',
  MODEL_TITLE_CHANGED: namespace + 'MODEL_TITLE_CHANGED',
  POLLING_FOR_3D_VIEWER_COMPLETED: namespace + 'POLLING_FOR_3D_VIEWER_COMPLETED',
  REAL_MATERIAL_RENDER_SHOWN: namespace + 'REAL_MATERIAL_RENDER_SHOWN',
  GLAZE_POSE_SAVED: namespace + 'GLAZE_POSE_SAVED',
  MODEL_DETAILS_TOGGLED: namespace + 'MODEL_DETAILS_TOGGLED'
};
